<template>
  <van-popup class="popup" v-model="pupShow" :position="isWeb?'center':'bottom'" round  get-container="#app" >
    <div class="popup_head flex flex-align-center">
      <p class="popup_title">Historical recommended records</p>
      <i class="popup_close" @click="pupShow = !pupShow"/>
    </div>
    <div class="popup_body">
      <ul class="popup_body_head flex">
        <li>Updated Time</li>
        <li v-for="(item,index) in titleArr" :key="index">{{ item }}</li>
      </ul>
      <ul class="list" v-if="logList != null">
        <li class="flex" v-for="(item,index) in (type == 'margin' ? logList.slice().reverse() : logList)" :key="index">
          
          <div v-if="isWeb">{{getMatchTime(item.updateTime,'YYYY.MM.dd HH:mm')}}</div>
          <div v-if="!isWeb">{{getMatchTime(item.updateTime,'YYYY.MM.dd')}}<br />{{getMatchTime(item.updateTime,'HH:mm')}}</div>
          <div v-if="type == 'margin'" :class="item.value[3] == 1 ? 'active' : ''">{{oddsCallFn(1, item.value[0], 'home')}}</div>
          <div v-if="type == 'margin'" :class="item.value[3] == 2 ? 'active' : ''">{{oddsCallFn(1, item.value[1], 'draw')}}</div>
          <div v-if="type == 'margin'" :class="item.value[3] == 3 ? 'active' : ''">{{oddsCallFn(1, item.value[2], 'away')}}</div>
          
          <div v-if="type != 'margin'" :class="getPredict(item,1)">{{oddsCallFn((logType == 'wpl_res' ? 1 : logType == 'handicap_res' ? 2 : 3), item.value[0], logArr[0])}}</div>
          <div v-if="type != 'margin'" :class="getPredict(item,2)">{{oddsCallFn((logType == 'wpl_res' ? 1 : logType == 'handicap_res' ? 2 : 3), item.value[1], logArr[1])}}</div>
          <div v-if="type != 'margin'" :class="getPredict(item,3)">{{oddsCallFn((logType == 'wpl_res' ? 1 : logType == 'handicap_res' ? 2 : 3), item.value[2], logArr[2])}}</div>
        </li>
      </ul>
    </div>
  </van-popup>
</template>
<script>
export default {
  props:{
    divergenceLogList: {
      type: [Array,Object],
      default:null
    }, 
    marginLogList: {
      type: [Array,Object],
      default:null
    }, 
    type: {
      type: String,
      default:null
    },
    setting: {
      type: Object,
      default: () => {}
    },
  },
  data(){
    return{
      pupShow: false,
      isWeb: true,
      logList: [],
      titleArr: [],
      logArr: ['home','draw','away'],
      logType: 'wpl_res',
      // titleObj:{
      //   '1x2': ['1','x','2'],
      //   'ah': ['Home','Handicap','Away'],
      //   'ou': ['Over','Total','Under']
      // }
    }
  },
  methods: {
    getLogList(){
      if(this.common.getTabChildId(this) == 1 && this.type == 'margin'){
        this.logList = this.marginLogList
        this.titleArr = ['1','x','2']
        this.logType = ''
      }else if(this.common.getTabChildId(this) == 1 && this.type == 'divergence'){
        this.logList = this.divergenceLogList.wpl_res.logList
        this.titleArr = ['1','x','2']
        this.logType = 'wpl_res'
        this.logArr = ['home','draw','away']
      }else if(this.common.getTabChildId(this) == 2){
        this.logList = this.divergenceLogList.handicap_res.logList
        this.titleArr = ['Home','Handicap','Away']
        this.logType = 'handicap_res'
        this.logArr = ['home','hand','away']
      }else if(this.common.getTabChildId(this) == 3){
        this.logList = this.divergenceLogList.overunder_res.logList
        this.titleArr = ['Over','Total','Under']
        this.logType = 'overunder_res'
        this.logArr = ['over','total','under']
      }

      console.log(this.logList);
      console.log(this.logArr);
    },
    // 获取更新时间
    getMatchTime(val,dateForm){
      let _val = val;
      let _tsz = this.setting.tsz;
      var setting=this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tsz=setting.tsz
      }

      let _time = this.common.getDateByArray(_tsz, _val);
      
      return this.common.dateStr(_time, dateForm);
    },

    // 指数返回
    oddsCallFn(ot, val, type){
      let _val = val, _type = type;
      if(typeof(_val) == 'undefined'){
        return '-'
      }
      return this.oddsLuckyChange(ot, _val, _type);
    },

    // 赔率转换
    oddsLuckyChange(ot, val, type2){
      let _val = val, _form = this.setting.oddsFormRadio, _type = ot, _type2 = type2;
      let _typeArr = ['home', 'away', 'over', 'under'];

      // if(_type == 1){
      //   return this.common.oddsFromChange(_val, _form);
      // }
      
      if(_type == 2 || _type == 3){
        if(_typeArr.includes(_type2)){
          // _val =  this.common.addValue(_val*1,1) - 1;
          _val =  Number(((this.common.addValue(_val*1,1)*100 - 100) /100).toFixed(2));
        }
      }
      if(_type2 == 'hand' || _type2 == 'total'){
        return _val;
      }
      return this.common.oddsFromChange(_val, _form);
    },

    //获取屏幕宽度
    handleResize() {
      if(typeof window!='undefined'){
        this.isWeb=(window.innerWidth>767?true:false)
      }
    },

    getPredict(item,type){
      // item.value[3] == 3 ? 'active' : ''
      if(this.logType == 'wpl_res'){
        if(item.value[3] == type){
          return 'active'
        }
      }else if(this.logType == 'overunder_res'){
        if((item.value[3] == 1 && type == 1) || (item.value[3] == 2 && type == 3)){
          return 'active'
        }
      }else if(this.logType == 'handicap_res'){
        if((item.value[3] == 1 && type == 1) || (item.value[3] == 2 && type == 3)){
          return 'active'
        }
      }
    },
  },
  mounted() {
    
    setTimeout(() => {
      this.handleResize();
    },100)

    this.$nextTick(() => {
      if(typeof window!='undefined'){
        window.addEventListener('resize', this.handleResize);
      }
    })
  },
  beforeDestroy() {
    if(typeof window!='undefined'){
      window.removeEventListener('resize', this.handleResize);
    }
  },
  watch:{
    // pupShow(){
    //   this.getLogList()
    // },
    // marginLogList(){
    //   this.getLogList()
    // },
    // divergenceLogList:{
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     this.getLogList()
    //   }
    // },
    type:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val){
          this.pupShow = true;
          this.getLogList()
        }
      }
    },
    pupShow:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val == false && this.type != ''){
          this.$emit('changePup','')
        }
      }
    },
    
  },
}
</script>
<style scoped lang="less"> 
  @import 'updataLog.less';  
</style>


// WEBPACK FOOTER //
// ./src/views/details/components/updataLog.vue